import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createOrReplyFeedback } from "@/redux/slices/feedbackSlice";
import { toast } from "react-toastify";
const ReviewModal = ({ showModal, setShowModal, tourId, userId }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.feedback);

  const [feedbackData, setFeedbackData] = useState({
    userId: userId,
    tourId: tourId,
    comments: "",
    rating: 1,
  });

  const handleChange = (e) => {
    setFeedbackData({ ...feedbackData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(createOrReplyFeedback(feedbackData)).unwrap();
    } catch (e) {
      toast.error(e.message);
      setShowModal(false);
      return;
    }

    setShowModal(false);
    toast.success("Tạo phản hồi thành công");
  };
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header>
        <Modal.Title>Viết đánh giá</Modal.Title>
        <a
          href="#"
          data-bs-dismiss="modal"
          aria-label="Close"
          style={{ position: "absolute", right: "16px" }}
          onClick={(e) => {
            e.preventDefault();
            setShowModal(false);
          }}
        >
          <i class="ti ti-x fs-16" style={{ fontSize: "2rem" }}></i>
        </a>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div class="row">
            <div class="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>
                  Đánh giá của bạn <span className="text-danger">*</span>
                </Form.Label>

                <br />

                <div className="d-inline-block">
                  <div class="selection-wrap">
                    <div class="d-inline-block">
                      <div class="rating-selction">
                        <input
                          type="radio"
                          name="rating"
                          value="5"
                          id="rating5"
                          onChange={handleChange}
                        />
                        <label for="rating5">
                          <i class="fa-solid fa-star"></i>
                        </label>
                        <input
                          type="radio"
                          name="rating"
                          value="4"
                          id="rating4"
                          onChange={handleChange}
                        />
                        <label for="rating4">
                          <i class="fa-solid fa-star"></i>
                        </label>
                        <input
                          type="radio"
                          name="rating"
                          value="3"
                          id="rating3"
                          onChange={handleChange}
                        />
                        <label for="rating3">
                          <i class="fa-solid fa-star"></i>
                        </label>
                        <input
                          type="radio"
                          name="rating"
                          value="2"
                          id="rating2"
                          onChange={handleChange}
                        />
                        <label for="rating2">
                          <i class="fa-solid fa-star"></i>
                        </label>
                        <input
                          type="radio"
                          name="rating"
                          value="1"
                          id="rating1"
                          onChange={handleChange}
                        />
                        <label for="rating1">
                          <i class="fa-solid fa-star"></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Form.Group>
            </div>

            <div class="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>
                  Viết đánh giá của bạn <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="comments"
                  required
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Đóng
          </Button>
          <Button type="submit" variant="primary">
            <i className="isax isax-edit-2 me-1"></i>Gửi đánh giá
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ReviewModal;
